import { render, staticRenderFns } from "./BuyStatPrint.vue?vue&type=template&id=7f2aaff6&"
import script from "./BuyStatPrint.vue?vue&type=script&lang=js&"
export * from "./BuyStatPrint.vue?vue&type=script&lang=js&"
import style0 from "./BuyStatPrint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports